export default Object.freeze({
	AdvancedAutomationRules: 'advanced_automation_rules',
	AllIndiciumValues: 'all_indicium_values',
	AllowAllMailClasses: 'allow_all_mail_classes',
	AllowRestrictedSheets: 'allow_restricted_sheets',
	AutomationRules: 'automation_rules',
	BlockSlaFromServiceBanner: 'block_sla_from_service_banner',
	BypassCleanseAddress: 'bypass_cleanse_address',
	ChangeContactInfo: 'change_contact_info',
	ChangePaymentMethod: 'change_payment_method',
	ChangePhysicalAddress: 'change_physical_address',
	CreateUnlimitedStores: 'create_unlimited_stores',
	Cubic: 'cubic',
	DisplayDhlByDefault: 'display_dhl_by_default',
	DisplayFedexByDefault: 'display_fedex_by_default',
	DisplayUpsByDefault: 'display_ups_by_default',
	EditCostCodes: 'edit_cost_codes',
	ExportPrintHistory: 'export_print_history',
	FciGap: 'fci_gap',
	FedexDirect: 'fedex_direct',
	FedexIntl: 'fedex_intl',
	FxIntlSpecified: 'fx_intl_specified',
	HideEstimatedDeliveryTime: 'hide_estimated_delivery_time',
	HideUnavailableFeatures: 'hide_unavailable_features',
	ManageUsers: 'manage_users',
	MustUseCostCodes: 'must_use_cost_codes',
	PmeiGap: 'pmei_gap',
	PmiGap: 'pmi_gap',
	PurchaseFromStore: 'purchase_from_store',
	PurchaseUspsInsurance: 'purchase_usps_insurance',
	RateAdvisor: 'rate_advisor',
	RateShop: 'rate_shop',
	ScheduleReports: 'schedule_reports',
	UpsDirect: 'ups_direct',
	ViewAdvancedReporting: 'view_advanced_reporting',
	ViewInsuranceHistory: 'view_insurance_history',
	ViewOnlineReports: 'view_online_reports',
	ViewReports: 'view_reports',
	WebPostage: 'web_postage',
	ZeroPostageBalance: 'zero_postage_balance',
});
